// 261010 P8e — dải "Chuẩn bị x/3 — còn thiếu" phía trên ba tab Tài sản. Không antd.
import React from 'react';
import type { BankPrep } from './bankPrepUtils';
import type { AssetTabKey } from './assetsTabsUtils';
import { prepStripView } from './assetPrepView';

const TAB_NAME: Record<AssetTabKey, string> = { CHARACTERS: 'Nhân vật', LOCATIONS: 'Bối cảnh', PROPS: 'Đạo cụ' };

interface Props {
  prep: BankPrep | null;
  onSelectTab: (tab: AssetTabKey) => void;
}

const WorkflowAssetPrepStrip: React.FC<Props> = ({ prep, onSelectTab }) => {
  const view = prepStripView(prep);
  if (!view) return null;
  return (
    <div className="wf-prep" data-testid="wf-prep-strip">
      <span>{view.readyText}</span>
      {view.allDone
        ? <span className="ok">— đủ</span>
        : <>
            <span>— còn thiếu:</span>
            {view.items.map((it, i) => (
              <button key={`${it.tab}-${it.text}-${i}`} type="button" className="wf-prep-lnk"
                aria-label={`Mở tab ${TAB_NAME[it.tab]} — ${it.text}`}
                onClick={() => onSelectTab(it.tab)}>{it.text}</button>
            ))}
          </>}
    </div>
  );
};

export default WorkflowAssetPrepStrip;
